'use strict';
module.exports = require('./PickList.vue');